<template>
  <div class="shc-edu-blog">
    <section class="shc-edu-blog__hero">
      <div class="shc-edu-blog__hero-noise"></div>
      <div class="shc-edu-blog__shell">
        <p class="shc-edu-blog__kicker">{{ $t('blog.shcEdu.kicker') }}</p>
        <h1 class="shc-edu-blog__title">
          {{ $t('blog.shcEdu.title') }}
          <span>{{ $t('blog.shcEdu.titleAccent') }}</span>
        </h1>
        <p class="shc-edu-blog__lead">{{ $t('blog.shcEdu.lead') }}</p>
        <div class="shc-edu-blog__meta">
          <span>{{ $t('blog.shcEdu.date') }}</span>
          <span>•</span>
          <span>{{ $t('blog.shcEdu.author') }}</span>
        </div>
      </div>
    </section>

    <main class="shc-edu-blog__main">
      <div class="shc-edu-blog__shell shc-edu-blog__grid">
        <article class="shc-edu-blog__article">
          <p>{{ $t('blog.shcEdu.p1') }}</p>

          <p>{{ $t('blog.shcEdu.p2') }}</p>

          <div class="shc-edu-blog__quote">
            {{ $t('blog.shcEdu.quote') }}
          </div>

          <h2>{{ $t('blog.shcEdu.sectionTitle') }}</h2>
          <ul>
            <li>{{ $t('blog.shcEdu.b1') }}</li>
            <li>{{ $t('blog.shcEdu.b2') }}</li>
            <li>{{ $t('blog.shcEdu.b3') }}</li>
            <li>{{ $t('blog.shcEdu.b4') }}</li>
          </ul>

          <p>{{ $t('blog.shcEdu.p3') }}</p>

          <figure class="shc-edu-blog__photo">
            <img src="https://songhancapital.com/assets/image/20251124.jpg" alt="SHC Capital cùng sinh viên trong buổi ngoại khóa" />
            <figcaption>{{ $t('blog.shcEdu.photoCaption') }}</figcaption>
          </figure>

          <p>{{ $t('blog.shcEdu.p4') }}</p>

          <div class="shc-edu-blog__source">
            <p>{{ $t('blog.shcEdu.sourceLabel') }}</p>
            <a
              href="https://due.udn.vn/vi-vn/khoa/thong-ke-tin-hoc/chitiet/id/21579/cid/1103"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://due.udn.vn/vi-vn/khoa/thong-ke-tin-hoc/chitiet/id/21579/cid/1103
            </a>
          </div>

          <section id="pupr-brokers" class="shc-edu-blog__brokers">
            <h2>{{ $t('blog.puPrime.openAccountTitle') }}</h2>
            <p class="shc-edu-blog__brokers-sub">{{ $t('blog.puPrime.openAccountSub') }}</p>

            <div class="shc-edu-blog__broker-grid">
              <article class="shc-edu-blog__broker-card">
                <h3>PU Prime</h3>
                <p><strong>{{ $t('blog.puPrime.linkLabel') }}:</strong> <a href="https://puvip.co/niANNr" target="_blank" rel="noopener noreferrer">puvip.co/niANNr</a></p>
                <p>
                  <strong>{{ $t('blog.puPrime.codeLabel') }}:</strong>
                  <button class="shc-edu-blog__copy-code" @click="copyCode('SHCcapital')">SHCcapital <i class="fas fa-copy"></i></button>
                </p>
                <button class="shc-edu-blog__guide-btn" @click="openGuide('pu')"><i class="fas fa-images"></i> {{ $t('blog.puPrime.guideBtn') }}</button>
                <a class="shc-edu-blog__broker-btn" href="https://puvip.co/niANNr" target="_blank" rel="noopener noreferrer">{{ $t('blog.puPrime.puBtn') }}</a>
              </article>

              <article class="shc-edu-blog__broker-card shc-edu-blog__broker-card--alt">
                <h3>Vantage</h3>
                <p><strong>{{ $t('blog.puPrime.linkLabel') }}:</strong> <a href="https://vigco.co/la-com/vi/SHCcapital" target="_blank" rel="noopener noreferrer">vigco.co/SHCcapital</a></p>
                <p>
                  <strong>{{ $t('blog.puPrime.codeLabel') }}:</strong>
                  <button class="shc-edu-blog__copy-code" @click="copyCode('SHCcapital')">SHCcapital <i class="fas fa-copy"></i></button>
                </p>
                <button class="shc-edu-blog__guide-btn" @click="openGuide('vantage')"><i class="fas fa-images"></i> {{ $t('blog.puPrime.guideBtn') }}</button>
                <a class="shc-edu-blog__broker-btn" href="https://vigco.co/la-com/vi/SHCcapital" target="_blank" rel="noopener noreferrer">{{ $t('blog.puPrime.vantageBtn') }}</a>
              </article>
            </div>
          </section>
        </article>

        <div v-if="showCopyToast" class="shc-edu-blog__toast">
          <i class="fas fa-check-circle"></i> {{ $t('blog.puPrime.toastMsg') }}
        </div>

        <div v-if="guideModal" class="shc-edu-blog__modal" @click="closeGuide">
          <div class="shc-edu-blog__modal-box" @click.stop>
            <button class="shc-edu-blog__modal-close" @click="closeGuide"><i class="fas fa-times"></i></button>
            <p class="shc-edu-blog__modal-caption">{{ guideModal.caption }}</p>
            <img :src="guideModal.src" :alt="guideModal.caption" class="shc-edu-blog__modal-img" />
          </div>
        </div>

        <aside class="shc-edu-blog__side">
          <div class="shc-edu-blog__card">
            <h3>{{ $t('blog.shcEdu.highlights') }}</h3>
            <div class="shc-edu-blog__chips">
              <span>{{ $t('blog.shcEdu.chip1') }}</span>
              <span>{{ $t('blog.shcEdu.chip2') }}</span>
              <span>{{ $t('blog.shcEdu.chip3') }}</span>
              <span>{{ $t('blog.shcEdu.chip4') }}</span>
            </div>
          </div>
          <div class="shc-edu-blog__card shc-edu-blog__card--cta">
            <h3>{{ $t('blog.shcEdu.connectTitle') }}</h3>
            <p>{{ $t('blog.shcEdu.connectDesc') }}</p>
            <router-link to="/contact">{{ $t('blog.shcEdu.contactNow') }}</router-link>
          </div>
        </aside>
      </div>
    </main>
  </div>
</template>

<script src="./shc-technical-analysis.js"></script>
<style src="./shc-technical-analysis.scss" lang="scss"></style>
